// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: #f08403;
  --sec-color:black;
}

html, body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  font-family: sans-serif;
  height: 100%;
  width: 100%;
}

h2 {
  color: white;
}

body {
  background-color: black;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

#rodape {
  max-width: 800px;
}

.form-check-label {
  color: var(--main-color);
  font-weight: lighter;
  font-size: 0.85rem;
}

#form-holder {
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 0.75rem;
}

.form-control {
  color: var(--main-color);
  border: 1px solid var(--main-color) !important;
}

.form-control:focus {
  color: var(--main-color);
  box-shadow: none;
}

#efeito_form {
  position: absolute;
  left: 0;
  bottom: -10%;
  width: 100%;
  user-select: none;
  z-index: -1;
}

#btn-submit {
  background-color: var(--main-color);
  color: white;
  border: none;
  box-shadow: none;
  border-radius: 1.25rem;
  font-weight: bolder;
  letter-spacing: 0.2rem;
}

#container-container {
  margin: auto;
  width: 55%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex-direction: inherit;
}

.iframe-container {
  position: relative;
  padding-bottom: 56.25%;
  width: 100%;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (min-width: 320px) and (max-width: 1024px) and (orientation: portrait) {
  #container-container {
    width: 100%;
    flex-direction: column;
    padding: 2em;
  }
  body {
    background-position: 8%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .iframe-container {
    width: 100%;
  }
  #efeito_form {
    bottom: -2%;
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/totvs/styles/main.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,wBAAA;EACA,oBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,2CAAA;EACA,sBAAA;AACJ;;AAEA;EACI,wBAAA;EACA,8CAAA;AACJ;;AAEA;EACI,wBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AACJ;;AAEA;EACI,mCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,YAAA;EAEA,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,sBAAA;EACA,WAAA;AADJ;;AAIA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAIA;EACI;IACI,WAAA;IACA,sBAAA;IACA,YAAA;EADN;EAIE;IACI,uBAAA;IACA,4BAAA;IACA,sBAAA;EAFN;EAKE;IACI,WAAA;EAHN;EAME;IACI,WAAA;EAJN;AACF;AAQA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AANF;;AASA,YAAA;AACA;EACE,0BAAA;AANF","sourcesContent":[":root{\n    --main-color: #f08403;\n    --sec-color:black;\n}\n\nhtml, body{\n    overflow-x: hidden;\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n    height: 100%;\n    width: 100%;\n}\n\nh2{\n    color: white;\n}\n\nbody{\n    background-color: black;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n#rodape{\n    max-width: 800px;\n}\n\n.form-check-label{\n    color: var(--main-color);\n    font-weight: lighter;\n    font-size: 0.85rem;\n}\n\n#form-holder{\n    background-color: rgba(255,255,255,0.75);\n    border-radius: 0.75rem;\n}\n\n.form-control{\n    color: var(--main-color);\n    border: 1px solid var(--main-color) !important;\n}\n\n.form-control:focus {\n    color: var(--main-color);\n    box-shadow: none;\n}\n\n#efeito_form{\n    position: absolute;\n    left: 0;\n    bottom: -10%;\n    width: 100%;\n    user-select: none;\n    z-index: -1;\n}\n\n#btn-submit{\n    background-color: var(--main-color);;\n    color: white;\n    border: none;\n    box-shadow: none;\n    border-radius: 1.25rem;\n    font-weight: bolder;\n    letter-spacing: 0.2rem;\n}\n\n#container-container{\n    margin: auto;\n\n    width: 55%;\n\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    flex-direction: inherit;\n}\n\n.iframe-container{\n    position: relative;\n    padding-bottom: 56.25%;\n    width: 100%;\n}\n\niframe{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n@media (min-width: 320px) and (max-width: 1024px) and (orientation: portrait)  {\n    #container-container{\n        width: 100%;\n        flex-direction: column;\n        padding: 2em;\n    }\n    \n    body{\n        background-position: 8%;\n        background-repeat: no-repeat;\n        background-size: cover;\n    }\n\n    .iframe-container{\n        width: 100%;\n    }\n\n    #efeito_form{\n        bottom: -2%;\n    }\n    \n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
